//* Libraries imports
import { useState } from "react";

//* Service imports
import { techinicalService } from "@features/techinicaldocument/TechinicalService";

//* Types imports
import type { MappingRule } from "@features/techinicaldocument/types";

type SaveConfigPayload = {
  mappings: MappingRule[];
  baseForm?: string;
};

export const useSaveConfig = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const saveConfig = async (id: string, payload: SaveConfigPayload) => {
    setLoading(true);
    setError(null);
    try {
      const response = await techinicalService.saveConfig(id, payload);
      if ("error" in response) {
        throw new Error("Erro ao salvar configurações");
      }
      return response;
    } catch (err: any) {
      setError(err.message || "Erro desconhecido ao salvar configurações");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { saveConfig, loading, error };
};
